import { Alert, AlertTitle } from "@material-ui/lab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";

import TabPanel from "@mui/lab/TabPanel";
import { Box } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Tab from "@mui/material/Tab";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { IReduxState } from "../store";
import Rapport from "../Rapport";
import SipderWebSite from "../SpiderWebSite";
import ApplisMobile from "../ApplisMobile";
import { userHasRight } from "../util/functions";
import GestionServiceXserver from "../Xserver";
import Messagerie from "../Messagerie";
import Partenaire from "../Partenaire";

function AppBody() {
  //redux
  // const { } = useSelector((state: IReduxState) => state.application);
  const dispatch = useDispatch();

  // hooks
  const [value, setValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <div>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="scrollable"
              scrollButtons
            >
              {/* <Tab
                label="Gestion fonctionnalités"
                value="1"
                disabled={!userHasRight("MOD01")}
              />

              <Tab
                label="Gestion niveau d'accès"
                value="2"
                disabled={!userHasRight("MOD02")}
              /> */}

              <Tab
                label="Rapport"
                value="1"
                disabled={!userHasRight("MOD03")}
              />

              <Tab
                label="Spider site web"
                value="2"
                disabled={!userHasRight("MOD04")}
              />

              <Tab
                label="Applications mobile"
                value="3"
                disabled={!userHasRight("MOD05")}
              />

              <Tab
                label="X-server service"
                value="4"
                // disabled={!userHasRight("MOD06")}
              />
              <Tab
                label="Messagerie"
                value="5"
                // disabled={!userHasRight("MOD06")}
              />
              <Tab
                label="Partenaire"
                value="6"
                // disabled={!userHasRight("MOD06")}
              />
            </TabList>
          </Box>
          {/* <TabPanel value="1">
            <GestionFonctionnalite />
          </TabPanel>
          <TabPanel value="2">
            <GestionNiveauAcces />
          </TabPanel> */}
          <TabPanel value="1">
            <Rapport />
          </TabPanel>
          <TabPanel value="2">
            <SipderWebSite />
          </TabPanel>
          <TabPanel value="3">
            <ApplisMobile />
          </TabPanel>
          <TabPanel value="4">
            <GestionServiceXserver />
          </TabPanel>
          <TabPanel value="5">
            <Messagerie />
          </TabPanel>
          <TabPanel value="6">
            <Partenaire />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
}

export default AppBody;
